<template>
  <div class="about-us">
    <div class="container">
      <!-- <h2>About Us</h2> -->
      <P>شماره تماس : 04133826195
        <br>
        فکس : 04133271001
        <br>
        +9تلگرام ،واتساپ و ایتا : 8932010538
        <br>

        WWW.PAS90.IR
      </P>
      <h3>تبریز ،مرکز برج تجارت جهانی <br>طبقه 16 واحد 7 / طبقه 21 واحد 3</h3>
      <div class="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3141.1545423898574!2d46.36223197615186!3d38.066781871913236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x401a1b0b8f5e491f%3A0xc24824b008f073f7!2sTabriz%20World%20Trade%20Tower%20(WTC)!5e0!3m2!1sen!2s!4v1713614998317!5m2!1sen!2s"
          width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </div>
</template>
  
  <script>
  export default {
    name: 'AboutUs',
  };
  </script>
  
  <style scoped>
  .about-us {
    width: auto;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #f2f2f2;
  }
  
  .container {
    line-height: 30px;
  max-width: 600px;
  padding: 20px;
  text-align: center;
  overflow-x: hidden; /* Add this line */
    }

  .social-links {
    display: flex;
    justify-content: center;
  }
  
  .social-link {
    margin: 0 10px;
  }
  
  .social-link i {
    font-size: 24px;
    color: #007bff;
  }
  
  .map-container {
    width: 100%;
    max-width: 600px;
    margin-top: 20px;
  }
  
  h2,
  h3 {
    color: #333;
  }
  
  p {
    color: #666;
  }
  
</style>
  
  